const ENVIRONMENT = 'Dev';

export const BASE_URL = ENVIRONMENT.toLowerCase() === 'prod' ?
    'https://vk772942r9.execute-api.us-east-1.amazonaws.com/unxnowprod/' :
    'https://gqctzln9sl.execute-api.us-east-1.amazonaws.com/dev/';